import { createContext } from '@web-stories-wp/react';
import type { FigmaImportContextType } from './types';

export const FigmaImportContext = createContext<FigmaImportContextType>({
  addFontPickerModal: () => {},
});
